import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=2c2d5f1e&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=2c2d5f1e&lang=scss&scoped=true&"
import style1 from "./Detail.vue?vue&type=style&index=1&id=2c2d5f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2d5f1e",
  null
  
)

export default component.exports